<template>
  <ul class="app-markdown-nav-list">
    <li
      v-for="item in navList"
      :key="item.index"
      :class="['app-markdown-nav-item', navActiveIndex === item.index && 'is__active']"
    >
      <a
        :href="`${item.url}`"
        :class="['app-markdown-nav-link', navActiveIndex === item.index && 'is__active']"
        :title="item.title"
        :data-index="item.index"
        @click="toggleNav(item.index)"
      >
        {{ item.title }}
      </a>
      <CommonMarkDownNav
        v-if="item.children && item.children.length > 0"
        :nav-list="item.children"
        :nav-active-index="navActiveIndex"
        @toggle-nav="toggleNav"
      >
      </CommonMarkDownNav>
    </li>
  </ul>
</template>
<script lang="ts" setup>
interface NavItem {
  title: string
  url: string
  index: number
  type?: string
  children?: NavItem[]
}
defineProps({
  navActiveIndex: {
    type: Number,
    default: -1
  },
  navList: {
    type: Array as PropType<NavItem[]>,
    default: () => []
  }
})
const emit = defineEmits(['toggleNav'])
const toggleNav = (index: number) => {
  emit('toggleNav', index)
}
</script>
<style lang="scss" scoped>
.app-markdown-nav-list {
  width: 100%;
  max-height: 100%;
  .app-markdown-nav-list {
    padding-left: 8px;
    .app-markdown-nav-item {
      font-size: 14px;
      //margin-bottom: 0;
      font-weight: 400;
      .app-markdown-nav-link {
        line-height: 24px;
      }
    }
  }
}
.app-markdown-nav-item {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  font-size: 16px;
  font-weight: 500;
  color: #c8ccd3;
  //margin-bottom: 12px;
}
.app-markdown-nav-link {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 30px;
  transition: 0.3s;
  &.is__active {
    color: #ffba00;
  }
}
@media not all and (hover: none) {
  .app-markdown-link:hover {
    &:first-child {
      .app-markdown-link-icon {
        transform: translateX(-20%);
      }
    }

    &:last-child {
      .app-markdown-link-icon {
        margin-left: 10px;
        transform: rotate(180deg) translateX(-20%);
      }
    }
  }
}
</style>
